import { ViewList } from '@mui/icons-material';
import { Box, IconButton, Tooltip, Typography, useTheme } from '@mui/material';
import React, { useEffect } from 'react';
import { WO2ToggleSwitch } from 'src/common';

interface Props {
  mergeReports: boolean;
  setMergeReportsParameter: (value: boolean) => void;
  setShowItemOderingModalParameter: (value: boolean) => void;
  disabled: boolean;
  canChangeReportOrder: boolean;
}

export const MergeReportsToggle = ({
  mergeReports,
  setMergeReportsParameter,
  setShowItemOderingModalParameter,
  disabled,
  canChangeReportOrder,
}: Props): JSX.Element => {
  const theme = useTheme();

  useEffect(() => {
    if (disabled && mergeReports) {
      setMergeReportsParameter(false);
    }
  }, [disabled, mergeReports, setMergeReportsParameter]);

  return (
    <Box display="flex" alignItems="center" gap={2}>
      <Box display="flex" alignItems="center">
        <WO2ToggleSwitch
          disabled={disabled}
          checked={mergeReports}
          onChange={() => {
            setMergeReportsParameter(!mergeReports);
          }}
          color="primary"
          name="mergeReports"
          inputProps={{ 'aria-label': 'primary checkbox' }}
        />
        <Typography variant="h4">Merge Reports</Typography>
      </Box>
      {/*
      'mergeReports' below refers to the toggle switch. 'canChangeReportOrder' is based on the number of reports selected. They are separate because
      having 1 report selected with an appendix uploaded will allow toggle switch to be turned on/off (merge report with appendix or download them
      separately as a zip file), but we should not show Manage Report Order button in that case, since there is only 1 report to order.
      */}
      {mergeReports && canChangeReportOrder && (
        <Tooltip title="Manage Report Order">
          <IconButton
            disabled={disabled}
            sx={{ outline: `1px solid ${theme.palette.primary.main}` }}
            color="primary"
            onClick={() => setShowItemOderingModalParameter(true)}
          >
            <ViewList />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
};
